import { useEffect } from 'react';

import { setOrdersExternalState } from '@/store/orders-external-api.store';
import {
    selectAssetStatus,
    selectOrderNoSource,
    selectOrderType,
} from '@repo/api-adapters/selectors/customer-assets.selectors';
import type { AssetDataType, AssetType } from '@repo/types/asset';
import { getCountryLanguage } from '@repo/utils';

/**
 * Syncs asset data into the Orders external API store whenever
 * the asset query produces fresh data.
 */
export const useOrdersExternalSync = (assetType: AssetType, assetId: string, data: AssetDataType | undefined): void => {
    useEffect(() => {
        if (data) {
            const { country } = getCountryLanguage();
            const orderNoSourceResult = selectOrderNoSource(data);
            const orderNoSource =
                typeof orderNoSourceResult === 'function' ? orderNoSourceResult(country) : orderNoSourceResult;

            setOrdersExternalState({
                assetData: {
                    assetId,
                    assetType,
                    orderType: selectOrderType(data),
                    orderStatus: selectAssetStatus(data),
                    orderNoSource,
                },
            });
        } else {
            setOrdersExternalState({ assetData: null });
        }
    }, [data, assetId, assetType]);

    // Clear on unmount
    useEffect(() => {
        return () => {
            setOrdersExternalState({ assetData: null });
        };
    }, []);
};
